<template>
  <div class="ws-state-textarea" :class="{ 'is-disabled': disabled, 'is-error': _isError }">
    <textarea-autosize
      ref="textareaAutosize"
      :placeholder="placeholder"
      :min-height="100"
      :max-height="500"
      :maxlength="maxlength"
      :value="value"
      @input="$_onInput($event)"
      @keyup="$_onKeyup"
      @focus.native="$_onFocus"
    />
    <div class="ws-state-textarea__bg"></div>
    <v-icon v-if="_isError" class="ws-state-textarea__icon" size="20">mdi-alert</v-icon>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import locales from '@/locales/zh_tw';
extend('min', {
  ...min,
  // message: "不得少於{length}位"
  message: locales['validate-min'],
});
extend('required', {
  ...required,
  // message: "此項目為必填"
  message: locales['validate-required'],
});
extend('email', {
  ...email,
  // message: "email格式不符"
  message: locales['validate-email'],
});
export default {
  props: {
    maxlength: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: '輸入...',
    },
    name: {
      type: String,
      default: null,
    },
    value: {},
    autoGrow: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isWarning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _isError() {
      return this.isWarning;
    },
  },
  methods: {
    $_onFocus() {
      if (this.disabled && this.$refs.textareaAutosize && this.$refs.textareaAutosize.$el) {
        this.$refs.textareaAutosize.$el.blur();
      }
    },
    $_onKeyup($event) {
      if (this.disabled) return;
      this.$emit('keyup', $event);
    },
    $_onInput($event) {
      if (this.disabled) return;
      let e = $event;
      if (!$event) e = '';
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss">
@import '../assets/scss/ws-state-textarea.scss';
</style>
